"use client";

import { useTranslations } from "use-intl";

import { cn } from "@/lib/utils";

interface SourceLink {
  source: string;
  label: string;
  url: string;
}

interface SourceLinksProps {
  links?: readonly SourceLink[] | null;
  className?: string;
}

const PROVIDER_STYLES: Record<string, string> = {
  discogs: "text-muted-foreground",
  musicbrainz: "text-muted-foreground",
};

export function SourceLinks({ links, className }: SourceLinksProps) {
  const t = useTranslations("shared.sourceLinks");

  if (!links?.length) return null;

  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-x-3 gap-y-1 pt-2 text-xs text-muted-foreground",
        className,
      )}
    >
      <span className="font-medium leading-none text-muted-foreground/80">{t("sources")}</span>
      {links.map((link) => (
        <a
          key={`${link.source}:${link.url}`}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            "inline-block leading-none transition-colors hover:text-foreground",
            PROVIDER_STYLES[link.source] ?? "text-muted-foreground",
          )}
          aria-label={link.label}
          title={link.label}
        >
          <span className="underline underline-offset-2">{link.label}</span>
        </a>
      ))}
    </div>
  );
}
